import {useNavigate} from "react-router-dom"
import {SubmitHandler, useForm} from "react-hook-form"
import {authAxios} from "lib/http/http.common"
import {ApiResponse} from "dto/ApiResponse"
import {AccessTokenInfo} from "dto/auth/Authentication"
import {setLocalAccessToken} from "lib/http/token-management"
import {showNotification} from "common/Notification"
import {FormErrorBox} from "common/FormErrorBox"

type LoginFormInputs = {
    userId: string,
    password: string,
}

const LoginForm = () => {
    const navigate = useNavigate()
    const {register, handleSubmit, formState: {errors}} = useForm<LoginFormInputs>()
    const login = async (userId: string, password: string) => {
        const response = await authAxios.post<ApiResponse<AccessTokenInfo>>("/auth", {
            userId,
            password,
        })
        setLocalAccessToken(response?.data?.body)
    }
    const onSubmit: SubmitHandler<LoginFormInputs> = async (data) => {
        try {
            await login(data.userId, data.password)
            navigate("/role");
        } catch (error) {
            showNotification("아이디나 비밀번호가 올바르지 않습니다.")
        }
    }
    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="login-body-all">
                <div className="login-img"/>
                <div className="login-box">
                    <div className="login-header">
                        <div className="mt10"/>
                        <span className="login-header-text"/>MEMBER MANAGEMENT
                    </div>
                    <div className="login-content">
                        <div className="login-from mt30">
                            <div className="login-ht">User ID</div>
                            <input type="text"
                                   {...register("userId", {required: "아이디를 입력하세요!"})}
                                   className="input-login" placeholder="Username"
                                   defaultValue=""
                            />
                            <FormErrorBox error={errors.userId}/>
                            <div className="login-ht mt10">Password</div>
                            <input type="password"
                                   {...register("password", {required: "비밀번호를 입력하세요!"})}
                                   className="input-login" placeholder="Password"
                                   defaultValue=""
                            />
                            <div className=" mt10">
                                <button className="btn btn-login is-fullwidth" >LOGIN</button>
                            </div>
                            <div className="copy">Copyright (c) FirstSnow All rights reserved</div>

                        </div>
                    </div>
                </div>
            </div>
        </form>
    )
}

export {LoginForm}